import store from 'state/store'

export default class BattleRoomsChannel {
    constructor(url) {
        this.ws = new WebSocket(url)
        this.ws.onmessage = this.onMessage.bind(this)
    }
    disconnect() {
        this.ws.close()
    }
    onMessage({ data }) {
        const { payload, type } = JSON.parse(data)
        if (!payload || !type) {
            console.error('Invalid action from battlerooms channel', data) // eslint-disable-line no-console
            return
        }

        store.dispatch({
            type,
            payload,
        })
    }
}



// WEBPACK FOOTER //
// ./channels/battlerooms.js